/**
 *
 * Transform the data of the availability source module.
 *
 */

/**
 *
 * Takes a flat array of availabilityCalendar items and transforms it to an
 * object with keys the year and value the array of items in that year.
 *
 * @param {array} data A flat array of availabiliyItems.
 *
 */
function dataTransformToYearKeys(data) {
  const newObject = data.reduce(function(datesObject, currentItem) {
    const currentYear = currentItem.date.getFullYear().toString();
    const reducedKeys = Object.keys(datesObject);

    if (reducedKeys.includes(currentYear)) {
      datesObject[currentYear].push(currentItem);
    } else {
      datesObject[currentYear] = [currentItem];
    }

    return datesObject;
  }, {});

  return newObject;
}

module.exports = {
  dataTransformToYearKeys
};



// WEBPACK FOOTER //
// ./resources/js/libraries/booking-availability-calendar/transform-booking-availability.js